module.exports = __webpack_public_path__ + "img/DE00483.434ea181.png";